import React, { useEffect, useState } from "react";

interface SearchInputProps {
  isTypeAble?: boolean;
  onValueChange?: (value: string) => void;
  onClearPress?: () => void;
  onFocus?: (value: boolean) => void;
  placeholder?: string;
  disableDelayDebounceFn?: boolean;
  className?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
    onValueChange = () => null,
    onClearPress = () => null,
      onFocus = () => false,
      placeholder = "Search...",
      className = "",
      disableDelayDebounceFn = false,
  }) => {

  const [searchText, setSearchText] = useState<string>('');
  const [delayDebounceFn, setDelayDebounceFn] = useState<any>(null);
  const [isOnFocus, setIsOnFocus] = useState(false);

  useEffect(() => {
    return () => {
      if (delayDebounceFn != null) {
        clearTimeout(delayDebounceFn);
      }
    };
  }, []);

  //function reduce the api call, because we should not called api until user finish typing
  const callSearchInterval = (value: string) => {
    if (delayDebounceFn != null) {
      clearTimeout(delayDebounceFn);
      setSearchText(value);
    }
    setDelayDebounceFn(
      setTimeout(() => {
        setSearchText(value);
        onValueChange(value);
      }, 500),
    );
  };


  return (
    <div className={`search-input-container ${className}`}>
      <div className="search-input-wrapper">
        <input
          type="text"
          value={searchText}
          onChange={(e) => disableDelayDebounceFn
            ? onValueChange(e.target.value)
            : callSearchInterval(e.target.value) }
          placeholder={placeholder}
          className="search-input"
        />
        {searchText?.length > 0 && (
          <button
            type="button"
            onClick={()=> {

            setSearchText('');
            onClearPress();
            }}
            className="clear-button"
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchInput;
